import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface HotMoviesProps {
  movies: Movie[];
}

export default function HotMovies({ movies }: HotMoviesProps) {
  return (
    <section className="w-full px-4 md:px-6 py-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              观众口碑最佳的高分影片
            </p>
          </div>
          <Link
            to="/category/juqing"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer"
          >
            更多推荐 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}